import { useContext } from 'react'
import OrderFilter from 'store/order-filter'
import FactorFilter from 'store/factor-filter'
import ProductStatsFilter from 'store/productStats-filter'

const useFilter = (type) => {
    let contextType = {
        'order': OrderFilter,
        'factor': FactorFilter,
        'stats': ProductStatsFilter
    }
    return useContext(contextType[type]);

}

export default useFilter;